module.exports = __webpack_public_path__ + "static/media/coming-soon.81db7fd9.jpg";